import { Box, Button, Divider, List, Stack, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import NotificationListItem from "./NotificationListItem";

function NotificationPanel({
  notifications,
  compact = false,
  title = "Notifications",
  subtitle,
  actionLabel,
  actionTo,
  onActionClick,
  onItemClick,
  emptyMessage = "No notifications available.",
}) {
  return (
    <Box>
      <Stack
        direction="row"
        sx={{
          mb: 1.5,
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Box>
          <Typography variant={compact ? "subtitle1" : "h5"} fontWeight={800}>
            {title}
          </Typography>
          {subtitle ? (
            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
              {subtitle}
            </Typography>
          ) : null}
        </Box>

        {actionLabel && actionTo ? (
          <Button
            component={RouterLink}
            to={actionTo}
            onClick={onActionClick}
            sx={{ textTransform: "none", fontWeight: 700 }}
          >
            {actionLabel}
          </Button>
        ) : null}
      </Stack>

      <Divider sx={{ mb: 1.5 }} />

      <List disablePadding>
        {notifications.length ? (
          notifications.map((notification) => (
            <NotificationListItem
              key={notification.id}
              notification={notification}
              compact={compact}
              onClick={() => onItemClick?.(notification)}
            />
          ))
        ) : (
          <Typography variant="body2" color="text.secondary" sx={{ py: 2 }}>
            {emptyMessage}
          </Typography>
        )}
      </List>
    </Box>
  );
}

export default NotificationPanel;
